import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-9">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">用户好评</h2>
          <p className="mt-2 text-sm text-foreground-500">来自真实用户的声音</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="flex flex-col gap-3 p-5 md:p-6 bg-background-100 rounded-lg border border-background-200/70"
            >
              <div className="flex gap-1 text-primary-400">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                "{item.text}"
              </p>
              <div className="flex items-center justify-between pt-2 border-t border-background-200/50">
                <span className="text-sm font-semibold text-foreground-800">{item.name}</span>
                <span className="text-xs text-foreground-500">{item.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}